module.exports = __webpack_public_path__ + "static/img/invite_link_popup.5126618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/mid-autumn/popup/invite_link_popup.png
// module id = wQ4m
// module chunks = 7